import { Box, Stack, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { useGlobalContext } from "@root/context";
import { isAuthorize } from "@styleguide";
import clsx from "clsx";
import { PrescriptionTableRow, classes } from "./styles";

export const PrescriptionsHeader = () => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("desktop"));
  const { user } = useGlobalContext();
  const isFullPartner =
    user.roleV2.value === "fullPartner" && isAuthorize(user.roleV2, ["offers.social.prescription.operator"]);
  return (
    <PrescriptionTableRow sx={{ scrollbarGutter: "stable", pl: 2 }}>
      <Stack
        className={clsx(classes.root, classes.header)}
        sx={(theme) => ({ borderBottom: `solid 1px ${theme.palette.gray.main}` })}
      >
        <Typography className={`${classes.cell} ${classes.candidate}`} variant="subtitle2SemiBold" color="primary">
          Candidat
        </Typography>
        <Typography className={`${classes.cell} ${classes.phone}`} variant="subtitle2SemiBold" color="primary">
          Téléphone
        </Typography>
        {isDesktop && (
          <>
            <Typography className={`${classes.cell} ${classes.place}`} variant="subtitle2SemiBold" color="primary">
              Résidence
            </Typography>
            <Typography
              className={`${classes.cell} ${classes.accompaniement}`}
              variant="subtitle2SemiBold"
              color="primary"
            >
              Accompagnements
            </Typography>
          </>
        )}
        <Typography className={`${classes.cell} ${classes.status}`} variant="subtitle2SemiBold" color="primary">
          Statut
        </Typography>
        {isDesktop && (
          <Typography className={`${classes.cell} ${classes.author}`} variant="subtitle2SemiBold" color="primary">
            Auteur
          </Typography>
        )}
        <Typography
          className={`${classes.cell} ${classes.prescriptionDate}`}
          variant="subtitle2SemiBold"
          color="primary"
        >
          Date
        </Typography>
        {isFullPartner && <Box className={`${classes.cell} ${classes.action}`} />}
      </Stack>
    </PrescriptionTableRow>
  );
};
